import React from "react";
import '../../styles/QuillProMinayla.css';
import { connect } from 'react-redux';
import InvoicesTable from './InvoicesTable';
import InvoiceSelection from './InvoiceSelection';
import Modal from './Modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import { getInvoices, getInvoiceAmounts } from '../../actions/AccountingActions';
import InvoicePayModal from '../Invoice/InvoicePayModal';

class Accounting extends React.Component {
    state = {
        activeTab: 'all',
        searchTerm: '',
        pageIndex: 0,
        maxRows: 25
    }

    componentDidMount() {
        const { activeTab, maxRows, pageIndex } = this.state;
        const { getInvoiceAmounts, getInvoices } = this.props;

        getInvoiceAmounts();
        getInvoices(activeTab, pageIndex, maxRows, "");

    }

    componentDidUpdate() {
        const { invoicesTab, invoicesPageIndex, getInvoices, isLoading, showingMax, searchText } = this.props;
        let { activeTab, maxRows, pageIndex, searchTerm } = this.state;
        if ((invoicesTab !== activeTab || pageIndex !== invoicesPageIndex || maxRows !== showingMax || searchTerm !== searchText) && !isLoading) {
            if (searchTerm !== searchText) {
                pageIndex = 1;
            }

            getInvoices(activeTab, pageIndex, maxRows, searchTerm);
        }

    }

    onTabClick = tabName => {
        if (tabName !== this.state.activeTab) {
            this.setState({
                activeTab: tabName,
                pageIndex: 0
            });
        }
    };

    onSelectMaxRows = e => {
        const rows = e.target.value;

        if (this.state.maxRows !== rows) {
            this.setState({
                maxRows: rows,
                pageIndex: 0
            });
        }
    };

    formatMoney = price => {
        let USDollar = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
        });
        if (!price) price = 0;
        return USDollar.format(price);
    }

    closeModal = () => {
        this.setState({ showModal: false });
    };

    render() {

        const { activeTab, maxRows, pageIndex } = this.state;
        const { isLoading, counts, showingCount } = this.props;

        let pages = 0;
        if (!isLoading && counts) {
            const count = counts[activeTab];
            pages = Math.trunc(count / maxRows) + (count % maxRows > 0 ? 1 : 0);
        }

        return (
            <main className="main-content row d-flex justify-content-center" role="main" style={{ width: '100%' }}>
                <Modal />
                <div className="col-9">
                    <div className="row">
                        <div className="col-lg-2 d-flex align-items-center">
                            <InvoiceSelection />
                        </div>
                        <div className="col-lg-8 d-flex justify-content-center align-items-center">
                            <button className={`btn ${(this.state.activeTab === 'all' ? 'btn-primary' : 'btn-light')} mr-4`}
                                onClick={() => this.onTabClick('all')}>
                                <span className="btn-group-title">All Invoices</span><br />
                                <span className="btn-group-detail">{this.props.counts ? this.props.counts.all : 0}</span>
                            </button>
                            <div className="btn-group">
                                <button className={`btn ${(this.state.activeTab === 'currentBalance' ? 'btn-primary' : 'btn-light')}`}
                                    onClick={() => this.onTabClick('currentBalance')}>
                                    <span className="btn-group-title">Current Balance</span><br />
                                    <span className="btn-group-detail">{this.formatMoney(this.props.totalAmounts ? this.props.totalAmounts.currentBalance : 0)}</span>
                                </button>
                                <button className={`btn ${(this.state.activeTab === 'pastDue' ? 'btn-primary' : 'btn-light')}`}
                                    onClick={() => this.onTabClick('pastDue')}>
                                    <span className="btn-group-title">Past Due</span><br />
                                    <span className="btn-group-detail">{this.formatMoney(this.props.totalAmounts ? this.props.totalAmounts.pastDue : 0)}</span>
                                </button>
                                <button className={`btn ${(this.state.activeTab === 'paid' ? 'btn-primary' : 'btn-light')}`}
                                    onClick={() => this.onTabClick('paid')}>
                                    <span className="btn-group-title">Paid Invoices</span><br />
                                    <span className="btn-group-detail">{this.formatMoney(this.props.totalAmounts ? this.props.totalAmounts.paid : 0)}</span>
                                </button>
                            </div>
                        </div>
                        <div className="col-lg-2 d-flex align-items-center">
                            <div className="input-group">
                                <input
                                    type="text"
                                    className="form-control form-control-sm"
                                    placeholder="Quick search..."
                                    onChange={e => this.setState({ searchTerm: e.target.value })}
                                    value={this.state.searchTerm}
                                />
                                <div className="input-group-append">
                                    <button className="btn btn-primary waves-effect waves-light icon-btn">
                                        <FontAwesomeIcon icon={faSearch} size="lg" />
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    {
                        <div className="row pt-5">
                            <div className="col-lg-12">
                                <InvoicesTable
                                    searchTermParent={this.state.searchTerm}
                                    activeTabParent={this.state.activeTab}
                                    pageIndexParent={this.state.pageIndex}
                                    openModal={this.openModal}
                                />
                                {
                                    (!isLoading && counts && pages > 0) ? (
                                        <div className="d-flex justify-content-between align-items-center">
                                            <div><span>{`Showing ${showingCount} of ${counts[activeTab]} invoices`}</span></div>
                                            <div className="d-flex">
                                                {/* buttons show as ( [1] [2] [3] ) in the examples below */}
                                                {
                                                    // if this is the last page show second previous page button => ex.( show:[1] [2] current:[3] )
                                                    pageIndex + 1 === pages && pages >= 3 ?
                                                        <button className="btn btn-primary icon-btn mr-2" onClick={() => this.setState({ pageIndex: pageIndex - 2 })}>{pageIndex - 1}</button>
                                                        : null
                                                }
                                                {
                                                    // if this is not the first page show previous page button => ex.( show:[1] current:[2] [3] )
                                                    pageIndex > 0 ?
                                                        <button className="btn btn-primary icon-btn mr-2" onClick={() => this.setState({ pageIndex: pageIndex - 1 })}>{pageIndex}</button>
                                                        : null
                                                }

                                                {/* show the current page button => ex.( [1] show current:[2] [3] ) */}
                                                <button className="btn btn-info icon-btn mr-2">{pageIndex + 1}</button>

                                                {
                                                    // if there is more page after the current page show next page button => ex.( [1] current:[2] show:[3] )
                                                    pages > pageIndex + 1 ?
                                                        <button className="btn btn-primary icon-btn mr-2" onClick={() => this.setState({ pageIndex: pageIndex + 1 })}>{pageIndex + 2}</button>
                                                        : null
                                                }
                                                {
                                                    // if this is the first page show second next page button => ex.( current:[1] [2] show:[3] )
                                                    pageIndex === 0 && pages >= pageIndex + 3 ?
                                                        <button className="btn btn-primary icon-btn mr-2" onClick={() => this.setState({ pageIndex: pageIndex + 2 })}>{pageIndex + 3}</button>
                                                        : null
                                                }
                                            </div>
                                            <div className="d-flex align-items-center">
                                                <span className="mr-2">Show</span>
                                                <select className="form-control" onChange={e => this.onSelectMaxRows(e)} value={maxRows} >
                                                    <option value="10">10</option>
                                                    <option value="25">25</option>
                                                    <option value="50">50</option>
                                                </select>
                                            </div>
                                        </div>
                                    ) : null
                                }
                            </div>
                        </div>
                    }
                </div>
                <InvoicePayModal />
            </main>
        );
    }
}

const mapStateToProps = state => {

    return {
        counts: state.accountingData.counts,
        totalAmounts: state.accountingData.totalAmounts,
        invoicesTab: state.accountingData.invoicesTab,
        invoicesPageIndex: state.accountingData.invoicesPageIndex,
        isLoading: state.accountingData.isLoading,
        showingCount: state.accountingData.list ? state.accountingData.list.length : 0,
        showingMax: state.accountingData.showingMax,
        searchText: state.accountingData.searchText
    };
};

const mapDispatchToProps = dispatch => {
    return {
        getInvoiceAmounts: () => dispatch(getInvoiceAmounts()),
        getInvoices: (tab, pIndex, rows, searchTerm) => dispatch(getInvoices(tab, pIndex, rows, searchTerm))
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(Accounting);


// WEBPACK FOOTER //
// ./src/view/Accounting/Accounting.js